import React, { useState } from "react";
import IconOnlyButton from "../icon-only-button/IconOnlyButton";
import { colors } from "../../../themes/Colors";
import BaseButtons from "../base-buttons/BaseButtons";

const ProfileHeader = ({
  onProfileClick,
  backgroundColor,
  username,
  onMobileClick,
  onAgencyClick,
  isCustomer,
}) => {
  const [changeModule, setChangeModule] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        display: "flex",
        justifyContent: "right",
        backgroundColor: backgroundColor,
        transition: "all 0.4s",
        zIndex: isCustomer ? 1 : null,
      }}
    >
      <div
        style={{
          marginRight: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        {isCustomer ? null : (
          <div style={{ marginRight: 20, position: "relative" }}>
            <BaseButtons
              label={"CHANGE MODULE"}
              color={"#000000"}
              borderRadius={8}
              height={35}
              width={150}
              onClick={() => setChangeModule(true)}
            />
            <div
              style={{
                height: changeModule ? (isCustomer ? 140 : 140) : 0,
                width: "100%",
                position: "absolute",
                backgroundColor: colors.white,
                borderRadius: 8,
                display: "flex",
                flexDirection: "column",
                top: 0,
                zIndex: 300,
                transition: "height 0.3s",
                overflow: "hidden",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <div style={{ height: 8 }} />
              {isCustomer ? (
                <BaseButtons
                  label={"GO ADMIN"}
                  backgroundColor={colors.greenLight}
                  borderRadius={8}
                  height={35}
                  width={"90%"}
                  onClick={onMobileClick}
                  disabled={true}
                />
              ) : (
                <BaseButtons
                  label={"GO TO MOBILE"}
                  backgroundColor={colors.greenLight}
                  borderRadius={8}
                  height={35}
                  width={"90%"}
                  onClick={onMobileClick}
                />
              )}

              <div style={{ height: 10 }} />
              <BaseButtons
                label={"GO TO AGENCY"}
                backgroundColor={colors.greenLight}
                borderRadius={8}
                height={35}
                width={"90%"}
                onClick={onAgencyClick}
                disabled={true}
              />
              <div style={{ height: 10 }} />
              <BaseButtons
                label={"CANCEL "}
                backgroundColor={colors.orangeDark}
                borderRadius={8}
                height={35}
                width={"90%"}
                onClick={() => setChangeModule(false)}
              />
              <div style={{ height: 10 }} />
            </div>
          </div>
        )}

        <div
          style={{
            marginRight: 10,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 14,
          }}
        >
          {username}
        </div>
        <IconOnlyButton
          onClick={onProfileClick}
          iconImage={require("../../../images/icons/pofileWhite.png")}
        />
      </div>
    </div>
  );
};

export default ProfileHeader;
